<template>
  <transition
    name="fade"
    tag="div">
    <div
      v-if="!closed"
      :class="wrapClasses"
      :style="wrapStyle">
      <div class="flex">
        <div
          v-if="showIcon"
          class="s-alert-icon">
          <slot name="icon">
            <sIcon :type="iconType"/>
          </slot>
        </div>
        <div
          v-if="hasTitle"
          class="s-alert-message">
          <slot/>
        </div>
      </div>
      <span class="s-alert-desc"><slot name="desc"/></span>
      <a
        v-if="closable"
        class="s-alert-close"
        @click="close">
        <slot name="close">
          <sIcon
            size="12"
            type="cross"/>
        </slot>
      </a>
    </div>
  </transition>
</template>
<script>
import sIcon from './icon'
/**
 * Блок с сообщением
 * @displayName Alert
 */
export default {
  name: 'sAlert',
  data() {
    return {
      closed: false,
      desc: false,
      hasTitle: true
    }
  },
  components: {
    sIcon
  },
  methods: {
    close(e) {
      this.closed = true
      this.$emit('on-close', e)
    }
  },
  computed: {
    wrapStyle() {
      const style = {}
      if (this.width) {
        style.width = this.width
      }
      return style
    },
    wrapClasses() {
      return [
        's-alert',
        `s-alert-${this.type}`,
        {
          ['s-alert-with-icon']: this.showIcon,
          ['s-alert-with-desc']: this.desc,
          ['s-alert-with-banner']: this.banner,
          ['s-alert-min-height']: this.minHeight,
          ['s-alert-small']: this.small,
          
        }
      ]
    },
    iconType() {
      let type = ''
      switch (this.type) {
      case 'success':
        type = 'accept'
        break
      case 'info':
        type = 'info'
        break
      case 'warning':
        type = 'reminder'
        break
      case 'error':
        type = 'cancel'
        break
      default:
      }
      return type
    }
  },
  mounted() {
    this.hasTitle = this.$slots.default !== undefined
    this.desc = this.$slots.desc !== undefined
  },
  props: {
    /**
     * Стиль отображения. По умолчанию `info`
     */
    type: {
      validator: function (value) {
        const correct = ['success', 'info', 'warning', 'error'].indexOf(value) !== -1
        return correct
      },
      default: 'info'
    },
    /**
     * Возможность закрыть
     */
    closable: {
      type: Boolean,
      default: false
    },
    /**
     * Отображаем иконку
     */
    showIcon: {
      type: Boolean,
      default: false
    },
    /**
     * Стиль без закруглений
     */
    banner: {
      type: Boolean,
      default: false
    },
    /**
     * Компактный размер
     */
    small: {
      type: Boolean,
      default: false
    },
    /**
     * применяем `height: min-content;` для минимальной высоты
     */
    minHeight: {
      type: Boolean,
      default: false
    },
    /**
     * Ширина блока
     */
    width: {
      type: [String, Number]
    }
  },
}
</script>
